// ======================================================================
// File Name       : LearningHistoryCSVDownloadContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as csvDownloadActions from '../../../actions/csvDownloadAction';
import DialogConfirm from '../../../components/DialogConfirm';
import Header from '../../../components/Header';
import CustomLink from '../../../components/button/CustomLink';
import ModalConductor from '../../../components/modal/ModalConductor';
import LoginHistoryCSVForm from '../../../components/userHistory/csv/LoginHistoryCSVForm';
import { DEFAULT_DATE_FORMAT_SEARCH } from '../../../constants';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import { LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD } from '../../../constants/PathConstants';

class LoginHistoryCSVDownloadContainer extends Component {
  constructor() {
    super();
    this.state = {
      showExportModal: false,
      isSuperuserLoginHistoryCSVPage: false,
    };
    this.csvDownloadHandler = this.csvDownloadHandler.bind(this);
    this.openExportDialog = this.openExportDialog.bind(this);
    this.onDialogExportCancel = this.onDialogExportCancel.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.path.indexOf(LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD) > -1) {
      this.setState({
        isSuperuserLoginHistoryCSVPage: true,
      });
    }
  }

  /**
   * Handle event when CSV出力 button is clicked
   */
  csvDownloadHandler() {
    const { formValues } = this.props;
    const { isSuperuserLoginHistoryCSVPage } = this.state;

    const {
      targetUserType,
      createdDateFrom,
      createdDateTo,
    } = formValues;

    const param = {};
    if (targetUserType && parseInt(targetUserType, 10) > -1) {
      param.userType = parseInt(targetUserType, 10);
    }
    param.isSuperuserLoginHistoryCSVPage = isSuperuserLoginHistoryCSVPage;

    createdDateFrom && (param.targetDateFrom = moment(createdDateFrom)
      .startOf('day').format(DEFAULT_DATE_FORMAT_SEARCH));
    createdDateTo && (param.targetDateTo = moment(createdDateTo)
      .endOf('day').format(DEFAULT_DATE_FORMAT_SEARCH));

    this.props.dispatch(csvDownloadActions.postGetLoginHistoryData(param));
    this.setState({ showExportModal: false });
  }

  /**
   * Handle open export dialog
   */
  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  /**
   * Handle Cancel button on export dialog
   */
  onDialogExportCancel() {
    this.setState({ showExportModal: false });
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { formValues, invalid } = this.props;
    const { isSuperuserLoginHistoryCSVPage } = this.state;

    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          text="戻る"
          icon="bi bi-chevron-left"
          onClick={this.goBack}
        />
        <Header name={isSuperuserLoginHistoryCSVPage ? 'SuperUserログイン履歴のダウンロード' : 'ログイン履歴のダウンロード' } />
        <LoginHistoryCSVForm
          {...formValues}
          openExportDialog={this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT_USER_HISTORY, null)}
          isSuperuserLoginHistoryCSVPage={isSuperuserLoginHistoryCSVPage}
          invalid={invalid} // Step 10.0.0
        />
        <ModalConductor />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onDialogExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.csvDownloadHandler}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loginHistoryCSVDownload,
  } = state.csvDownload;
  const formValues = getFormValues('loginHistoryCSV')(state);

  return {
    ...{ loginHistoryCSVDownload },
    formValues,
    initialValues: loginHistoryCSVDownload,
    invalid: isInvalid('loginHistoryCSV')(state), // Step 10.0.0
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'loginHistoryCSV', // a unique identifier for this form
  touchOnChange: true,
})(LoginHistoryCSVDownloadContainer));
